(() => {
  const menu = document.querySelector('[data-ice-global-menu]');
  const openButton = document.querySelector('[data-ice-global-menu-open]');
  const closeButton = document.querySelector('[data-ice-global-menu-close]');
  if (!menu || !openButton || !closeButton) return;

  const setOpen = (open) => {
    menu.hidden = !open;
    openButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('ice-global-lock', open);
    if (open) closeButton.focus();
  };

  openButton.addEventListener('click', () => setOpen(true));
  closeButton.addEventListener('click', () => setOpen(false));
  menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !menu.hidden) setOpen(false);
  });
})();
